import { makeStyles, shorthands, tokens, typographyStyles } from '@fluentui/react-components';

export const useAdPreviwerStyles = makeStyles({
  root: {
    width: '542px',
    height: '600px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '65px',
    ...shorthands.padding(tokens.spacingVerticalL, '0'),
  },
  carouselWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '500px',

    '& .carousel-inner': {
      height: '100%',
      paddingBottom: '0',

      '& .item': { height: '100%' },
    },

    '& .ad-placement-preview': {
      flexGrow: 1,
    },

    '& .custom-carousel-controls-and-indicators': {
      position: 'initial',
    },
  },
  placementAndCaptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  placementContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: '1',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  caption: {
    color: tokens.colorNeutralForeground3,
    ...typographyStyles.caption1,
  },
});
